import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PaymentListItem, PaymentListRequestModel } from '@/models/dictionary/payment-list.model';

export default class GetPaymentListRequest extends ApiResourceMethod<PaymentListItem[]> {
  public perform(wlSlug: string, filterList: PaymentListRequestModel): Promise<PaymentListItem[]> {
    return this.performer.requestWithMapper(
      {
        params: filterList,
        url: `${wlSlug}/dictionary/payment`,
      },
      (payload: BaseResponse<PaymentListItem[]>) => {
        return payload.data;
      },
    );
  }
}
